module.exports = __webpack_public_path__ + "img/default-background.703b0f83.webp";